/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_EveryInputs */

const vi_irrigation_schedule_every = /** @type {(inputs: Irrigation_Schedule_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lặp lại mỗi (phút)`)
};

/**

* @param {Irrigation_Schedule_EveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_every = /** @type {((inputs?: Irrigation_Schedule_EveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_EveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_every(inputs)
});